module.exports = __webpack_public_path__ + "img/1.64e4be46.png";